import React from 'react';
import './PrivacyPolicy.css';
import { useTranslate } from 'react-translate';

function PrivacyPolicy() {

    const t = useTranslate("privacyPolicy");
    return (
        <div className="privacy-policy-container" id="policyContainer">
            <h3 style={{ marginTop: 0 }}>{t("internetWebSiteTitle")}</h3>
            <p>{t("articlePresentation")}</p>
            <p><b>{t("owner")}</b>{t("ownerAdress")}</p>

            <h3>{t("servicesProvidedTitle")}</h3>
            <p>{t("websitePurpose")}</p>
            <p>{t("documentProperty")}</p>

            <h3>{t("technicalDataLimitationTitle")}</h3>
            <p>{t("rgpdWebiste")}</p>
            <p>{t("objectives")}</p>
            <p>{t("excenseResponsability")}</p>


            <h3>{t("personalDataTitle")}</h3>
            <p>{t("reglementation")}</p>
            <p>{t("dataUse")}</p>

            <h3>{t("processedDataTitle")}</h3>
            <p>{t("userIdentificationData")}</p>
            <p>{t("serviceDataUse")}</p>
            <p>{t("serviceLocationUse")}</p>


            <h3>{t("dataDestinationTitle")}</h3>
            <p>{t("partner")}</p>
            <p>{t("noInformationShared")}</p>


            <h3>{t("dataConservationTitle")}</h3>
            <p>{t("dataConservationTime")}</p>


            <h3>{t("individualRightsTitle")}</h3>
            <p>{t("contact")}</p>            
        </div>
    )
};

export default PrivacyPolicy;